module.exports = __webpack_public_path__ + "img/mentor4.76aff93.jpg";